module.exports = __webpack_public_path__ + "img/yarkov.3ab609de.jpg";